import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class BreezeWaysService {

	constructor(private http: HttpClient) { }

	saveAllProperties(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/breezeways/save-all-properties`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	saveAllReservations(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/breezeways/save-all-reservations`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	saveAllReservationsByProperty(shortTermRentalId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/breezeways/save-all-reservations-by-property/${shortTermRentalId}`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	saveProperty(shortTermRentalId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/breezeways/save-property/${shortTermRentalId}`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	saveReservation(reservationId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/breezeways/save-resevation/${reservationId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	syncExpenseByDays(daysForStartDate?: number): Observable<ApiResponse> {
		const query = daysForStartDate != null ? `?daysForStartDate=${daysForStartDate}` : '';
		return this.http.get<ApiResponse>(`${environment.apiUrl}/expenses/sync-breezway-expense${query}`).pipe(retry({ count: 2, delay: 1500 }));
	}

}